/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Startdate1Inputs */

const zh_billing_startdate1 = /** @type {(inputs: Billing_Startdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始日期`)
};

const en_billing_startdate1 = /** @type {(inputs: Billing_Startdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Date`)
};

const es_billing_startdate1 = /** @type {(inputs: Billing_Startdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de inicio`)
};

/**
* | output |
* | --- |
* | "Start Date" |
*
* @param {Billing_Startdate1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const billing_startdate1 = /** @type {((inputs?: Billing_Startdate1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Startdate1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_billing_startdate1(inputs)
	if (locale === "en") return en_billing_startdate1(inputs)
	return es_billing_startdate1(inputs)
});
export { billing_startdate1 as "billing_startDate" }